import React, { Component } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get, map } from 'lodash'
import { FormikDropdownField } from './Dropdown'
import { useEffect } from 'react'
import { cityList } from '../../actions/city'

export const CitySelectField = ({formik_props, country_id, ...props}) => {

    const dispatch = useDispatch()
    const city_options = useSelector(() => cityList.getAsOptions())

    useEffect(() => {
        async function fetchStaticObjects() {
            dispatch(cityList.updatePaginationNumItemsPerPage(1000))
            dispatch(cityList.filterOnCountry(country_id))
            dispatch(cityList.fetchListIfNeeded())
        }
        fetchStaticObjects()
    }, [country_id])


    return (
        <FormikDropdownField options={city_options}
                             formik_props={formik_props}
                             label="City"
                             {...props}
        />
    )
}
